<template>
  <div class="app-container">
    <!-- 导航栏 -->
    <HeaderNav />
    
    <!-- 主要内容区 -->
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    
    <!-- 页脚 -->
    <FooterInfo />
  </div>
</template>

<script>
import HeaderNav from './components/HeaderNav.vue';
import FooterInfo from './components/FooterInfo.vue';

export default {
  name: 'App',
  components: {
    HeaderNav,
    FooterInfo
  }
};
</script>


<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.main-content {
  flex: 1;
  position: relative;
  z-index: 1;
  transition: margin-top 0.3s ease;
}

/* 响应式调整主要内容区域的内边距 */
@media (max-width: 768px) {
  .main-content {
    padding-bottom: 20px;
  }
}

@media (max-width: 576px) {
  .main-content {
    padding-bottom: 15px;
  }
}
</style>